import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './bciPayment.css'
import Text from '../../components/text/Text'
import routes from '../../router/routes'
import CheckIcon from '../../assets/images/bci/check.png'
import ExclamationIcon from '../../assets/images/bci/exclamation.png'
import TimeIcon from '../../assets/images/bci/time.png'
import XIcon from '../../assets/images/bci/x.png'

import { clevertapEvents, labels } from '../../labels'
import { getProcessedBciPayment } from '../../services/payment'
import { track } from '../../ClevertapWrapper'
import { format } from 'date-fns'
import SvgIcon from '../../components/svgIcon/SvgIcon'

type ORDER_STATUS = 'REJECTED' | 'AUTHORIZED' | 'PENDING' | 'ERROR' | 'TIMEOUT'

export default function BciPayment() {
    const hasBCIOrderPending = localStorage.getItem('bci-payment')

    const [orderStatus, setOrderStatus] = useState<ORDER_STATUS>('PENDING')
    const [file, setFile] = useState<string>()

    const navigation = useNavigate()

    const navigateBack = () => {
        navigation(`/${routes.payment}`)
    }

    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)

    const paymentEventParms = {
        pageName: 'BciPayment',
        pageURL: routes.bci,
        date: format(new Date(), 'yyyy/MM/dd'),
        hour: format(new Date(), 'kk:mm:ss'),
        codComercio: user?.sEstablecimiento,
        nombreComercio: user?.sNombre,
        codLocal: user?.cLocal[0].sLocal,
        rut: user?.sRut,
        mailLogin: user?.sEmailContacto,
    }

    const checkStatus = async () => {
        try {
            const { status, fileInvoice } = await getProcessedBciPayment(
                hasBCIOrderPending
            )

            if (fileInvoice) {
                setFile(fileInvoice)
            }

            if (status === 'PENDING') {
                setTimeout(() => {
                    checkStatus()
                }, 1000)
                return
            }
            if (status === 'AUTHORIZED') {
                setOrderStatus('AUTHORIZED')
                return
            }
            if (status === 'REJECTED') {
                setOrderStatus('REJECTED')
                return
            }
            if (status === 'TIMEOUT') {
                setOrderStatus('TIMEOUT')
                return
            }
            setOrderStatus('ERROR')
        } catch (e) {
            setOrderStatus('ERROR')
        }
    }

    const openPdf = () => {
        if (file) {
            const byteCharacters = atob(file)
            const byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            const byteArray = new Uint8Array(byteNumbers)
            const blob = new Blob([byteArray], { type: 'application/pdf' })
            const url = URL.createObjectURL(blob)
            window.open(url)
        }
    }

    useEffect(() => {
        checkStatus()
    }, [])

    useEffect(() => {
        if (orderStatus === 'AUTHORIZED') {
            track(
                clevertapEvents.amiposweb_cobrafacil_pagopos_exito,
                paymentEventParms
            )
        }
    }, [orderStatus])
    useEffect(() => {
        if (orderStatus === 'REJECTED') {
            track(
                clevertapEvents.amiposweb_cobrafacil_pagopos_rechazada,
                paymentEventParms
            )
        }
    }, [orderStatus])
    useEffect(() => {
        if (orderStatus === 'PENDING') {
            track(
                clevertapEvents.amiposweb_cobrafacil_pagopos_pending,
                paymentEventParms
            )
        }
    }, [orderStatus])

    const PendingComponent = () => {
        return (
            <div className="bci-waitng-payment-card">
                <img src={TimeIcon} alt="time" style={{ marginBottom: 15 }} />
                <Text
                    label={labels.bciPayment.pending.line1}
                    variant="md-medium "
                    fontSize={24}
                    fontWeight={500}
                    color={'#184287'}
                />
                <Text
                    label={labels.bciPayment.pending.line2}
                    variant="md-medium titleStyle"
                    fontSize={24}
                    fontWeight={500}
                    color={'#184287'}
                />
                <Text
                    label={'...'}
                    variant="md-medium  bci-waitng-payment-dots"
                    fontSize={24}
                    fontWeight={500}
                    color={'#184287'}
                />
            </div>
        )
    }

    const FailedComponent = () => {
        return (
            <div className="bci-waitng-payment-card bci-waiting-payment-short-container">
                <img
                    src={ExclamationIcon}
                    alt="exclamation"
                    style={{ marginBottom: 15, gap: '16px' }}
                />
                <Text
                    label={labels.bciPayment.failed}
                    variant="md-medium "
                    fontSize={24}
                    fontWeight={500}
                    color={'#184287'}
                />
                <button onClick={navigateBack} className="bci-timeout-btn">
                    <Text
                        label="Volver a intentar cobro "
                        variant="md-medium"
                        fontSize={24}
                        fontWeight={500}
                        color={'#565656'}
                    />
                </button>
            </div>
        )
    }

    const SuccessComponent = () => {
        return (
            <div className="bci-waitng-payment-card bci-waiting-payment-short-container">
                <img src={CheckIcon} alt="check" style={{ marginBottom: 15 }} />
                <Text
                    label={labels.bciPayment.success}
                    variant="md-medium "
                    fontSize={24}
                    fontWeight={500}
                    color={'#184287'}
                />
                <div style={{ marginTop: 15, marginBottom: 5 }}>
                    {file ? (
                        <button
                            onClick={openPdf}
                            style={{
                                gap: 7,
                                display: 'flex',
                                cursor: 'pointer',
                                alignItems: 'center',
                                justifyContent: 'center',
                                textDecoration: 'underline',
                                backgroundColor: 'transparent',
                            }}
                        >
                            <Text
                                label="Descargar la boleta en PDF"
                                variant="bold"
                            />
                            <SvgIcon iconName="PdfIcon" />
                        </button>
                    ) : (
                        <div
                            style={{
                                gap: 7,
                                maxWidth: 350,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <div style={{ width: 30 }}>
                                <SvgIcon iconName="warning" />
                            </div>
                            <Text
                                variant="Caption3-13"
                                label="Se presentó un problema para generar la boleta electrónica. Por favor contacta a nuestro equipo de soporte."
                            />
                        </div>
                    )}
                </div>
            </div>
        )
    }

    const TimeoutComponent = () => {
        return (
            <div className="bci-error-payment-card">
                <img src={XIcon} alt="time" style={{ marginBottom: 15 }} />
                <Text
                    label={labels.bciPayment.timeout}
                    variant="md-medium "
                    fontSize={24}
                    fontWeight={500}
                    color={'#184287'}
                />
                <button onClick={navigateBack} className="bci-timeout-btn">
                    <Text
                        label="Volver a intentar cobro "
                        variant="md-medium"
                        fontSize={24}
                        fontWeight={500}
                        color={'#565656'}
                    />
                </button>
            </div>
        )
    }

    const ComponentToRender = () => {
        if (orderStatus === 'PENDING') return <PendingComponent />
        if (orderStatus === 'AUTHORIZED') return <SuccessComponent />
        if (orderStatus === 'TIMEOUT') return <TimeoutComponent />
        return <FailedComponent />
    }

    return (
        <div className="bci-waitng-payment-container">
            <ComponentToRender />
        </div>
    )
}
